import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ScrollService } from 'src/app/services/scroll.service';
@Component({
  selector: 'app-just-diagnosed',
  templateUrl: './just-diagnosed.component.html',
  styleUrls: ['./just-diagnosed.component.css'],
})
export class JustDiagnosedComponent implements OnInit, OnDestroy {
  lightText = '';
  darkText = '';
  cards: any[] = [
    {
      id: 'just-diagnosed-4047',
      title: 'Щойно встановили діагноз',
      link: '/get-support/what-to-do-if/just-diagnosed',
      dementiaMenuId: 2023,
    },
    {
      id: 'just-diagnosed-4048',
      title: 'Як зміниться моє щоденне життя та як зробити його комфортним?',
      link: '/get-support/what-to-do-if/just-diagnosed',
      dementiaMenuId: 2023,
    },
    {
      id: 'just-diagnosed-4050',
      title: 'Як подбати про свій психологічний стан',
      link: '/get-support/what-to-do-if/just-diagnosed',
      dementiaMenuId: 2023,
    },
    {
      id: 'just-diagnosed-4051',
      title: 'Медична та немедична терапія',
      link: '/get-support/what-to-do-if/just-diagnosed',
      dementiaMenuId: 2023,
    },
    {
      id: 'just-diagnosed-4052',
      title: 'Як подбати про свою безпеку',
      link: '/get-support/what-to-do-if/just-diagnosed',
      dementiaMenuId: 2023,
    },
  ];
  sectionCards: any[] = [];
  currentBreadcrumb: string | null = 'second';
  isLoaded = false;
  private routeSubscription: Subscription | null = null;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private scrollService: ScrollService,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      const routeId = params['secondId'];
      this.router.navigate([], { state: { id: routeId } });
      this.fetchCardList()
        .pipe(
          tap((data: any[]) => {
            this.lightText = data[0].contentLight;
            this.darkText = data[0].contentDark;

            this.sectionCards = data[0].menuSubTitle.map((el: any) => ({
              subMenuCards: [
                ...el.SubMenuCards.map((card: any) => ({
                  link:
                    '/get-support/what-to-do-if/just-diagnosed/' + card.cardId,
                  cardTitle: card.cardTitle,
                })),
              ],
            }));

            this.currentBreadcrumb = data[0].menuTitle;
            const element = document.querySelector(
              '[data-breadcrumb="second"]',
            );
            if (element) {
              element.innerHTML = data[0].menuTitle;
            }
            this.scrollService.setLoaded(true);
          }),
        )
        .subscribe();
    });
  }

  fetchCardList(): Observable<any[]> {
    const url = `https://nezabutni-backend.vercel.app/api/second-page?id=just-diagnosed`;
    return this.http.get<any[]>(url);
  }
  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
